import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TriggerGroupObjectEntity } from './trigger-group-object.entity';

@Index(
	'_trigger_group__object_field__fk__trigger_group__object__id_fk',
	['fkTriggerGroupObjectId'],
	{},
)
@Entity('_trigger_group__object_field')
export class TriggerGroupObjectFieldEntity extends BaseEntity {
	@Column('int', { name: '_fk__object_field__id', unsigned: true })
	public fkObjectFieldId!: number;

	@Column('int', { name: '_fk__trigger_group__object__id', unsigned: true })
	public fkTriggerGroupObjectId!: number;

	@ManyToOne(
		() => TriggerGroupObjectEntity,
		(triggerGroupObject) => triggerGroupObject.triggerGroupObjectFields,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__trigger_group__object__id', referencedColumnName: 'id' },
	])
	public fkTriggerGroupObject!: TriggerGroupObjectEntity;
}
